require('url-search-params-polyfill')

const $ = window.jQuery

/**
 * Enables 'MWB Post Forms' plugin specific scripting
 */
const PostForms = {

    /**
     * Initialise functionality
     */
    init() {

        // TODO - consider disabling for block editor

        // Initialise all present post forms
        this.initialisePostForms()

    },

    /**
     * Initialise all present post forms
     */
    initialisePostForms() {

        $('form[data-post-form-id]').each(function () {
            new PostForm($(this))
        })

    }

}

/**
 * A specific post form instance
 */
class PostForm {

    /**
     * Setup instance of post form
     * @param {jQuery el} $form_el Form element
     */
    constructor($form_el, settings = {}) {

        var vm = this

        vm.defaults = {
            pagination:             'load-more',    // Default pagination type (load-more or page numbers (TODO))
        }

        vm.initials = {
            plugin_name:            'Post Forms',
            last_requested_at:      0,              // Keeps track of previous timestamp of previous query
            last_query:             {},             // Keeps track of previous query
            last_page:              1,              // Keeps track of previous page number
            current_page:           1,              // Default current page number
            submit_type:            'on-change',    // When to query posts again (on-change, or on-submit)
            empty_html:             'No posts',     // HTML to display when no posts are found
            count_html:             '',             // HTML to display indicating amount of results
            total_post_count:       0,              // Amount of total posts from query (regardless of page)
            page_param:             'pg',           // Url parameter for current page number
            pagination_selector:    '.btn',         // jQuery selector for pagination button
            disable_params:         false,          // Disable url parameters entirely
            exclude_params:         [],             // Ignore setting and getting specific url parameters
        }

        $.extend(vm, vm.initials)
        vm.options          = $.extend({}, vm.defaults, settings)
        vm.originalSettings = vm.options

        vm.init($form_el)

    }

    /**
     * Initialise post form
     */
    init($form_el) {

        var vm = this

        vm.set_form_parts($form_el)
        vm.set_post_form_id($form_el)
        vm.set_script_var_options()
        vm.init_form()
        vm.last_requested_at    = (new Date()).getTime()
        vm.last_query           = vm.get_last_query()

    }

    /**
     * Send a warning to the console
     */
    send_warning(message) {
        console.warn(`${this.plugin_name} - ${message}`)
    }

    /**
     * Get current form data and url parameters combined
     */
    get_last_query() {

        var vm              = this,
            query           = vm.get_query(),
            last_query      = vm.get_all_url_params([vm.page_param, ...vm.exclude_params])

        return $.extend(query, last_query)

    }

    /**
     * Get current url parameters
     *
     * Optionally exclude list of given parameters
     */
    get_all_url_params(exclude_params = []) {

        // Skip function if url params are disabled
        if (this.disable_params) {
            return
        }

        // Otherwise build up url params
        var params = {}

        if (location.search) {
            var parts = location.search.substring(1).split('&')

            for (var i = 0; i < parts.length; i++) {
                var nv = parts[i].split('=')
                if (!nv[0] || exclude_params.includes(nv[0])) continue
                params[nv[0]] = nv[1] || true
            }
        }

        return params

    }

    /**
     * Store post form form elements
     */
    set_form_parts($form_el) {

        var vm = this

        vm.form_parts = {
            'form':         $form_el,
            'container':    $($form_el.attr('data-post-container')),
            'pagination':   $($form_el.attr('data-post-pagination')),
            'loading':      $($form_el.attr('data-post-loading')),
            'count':        $($form_el.attr('data-post-count')),
        }

        // Warn of any missing elements
        Object.keys(vm.form_parts).forEach(function(key) {

            if (vm.form_parts[key].length === 0) {
                vm.send_warning(`Missing ${key} element`)
            }

        })

    }

    /**
     * Store post form form elements
     */
    set_post_form_id($form_el) {
        this.post_form_id = $form_el.attr('data-post-form-id')
    }

    /**
     * Set PostForm script var options
     */
    set_script_var_options() {

        var vm = this

        if (typeof scriptVars['plugins']['postForms'][vm.post_form_id] != 'undefined') {

            var script_vars_options = scriptVars['plugins']['postForms'][vm.post_form_id]

            Object.keys(script_vars_options).forEach(function (key) {
                vm[key] = script_vars_options[key]
            })

        }

    }

    /**
     * Return post form form elements
     */
    get_form_parts() {
        return this.form_parts
    }

    /**
     * Get hidden page input
     */
    get_page_input() {

        var vm      = this,
            form    = vm.get_form_parts().form

        return form.find(`input[name="${vm.page_param}"]`)

    }

    /**
     * Initialise progress page button click event listener
     */
    get_progress_button() {

        var vm          = this,
            pagination  = vm.get_form_parts().pagination

        let progress_button = pagination.find(vm.pagination_selector)

        if (progress_button.length > 0) {
            return progress_button
        } else {
            vm.send_warning(`Progress button not found, tried looking for jQuery selector "${vm.pagination_selector}" inside "post-pagination" container. This can be changed using the "pagination_selector" option when registering the Post Form.`)
            return false
        }

    }

    /**
     * Initialise form event listeners
     */
    init_form() {

        var vm              = this,
            form            = vm.get_form_parts().form,
            progress_button = vm.get_progress_button()

        form.on('submit', function (e) {
            e.preventDefault()
            vm.populate_posts()
        })

        if (vm.submit_type == 'on-change') {

            form.find('input, select').on('change', function () {
                vm.populate_posts()
            })

        }

        if (progress_button) {

            progress_button.on('click', function (e) {
                e.preventDefault()

                $(window).trigger('mwb/plugin/post_forms/progressing_page', [vm])   // trigger post form page progressing event
                vm.progress_page()
            })

        }

    }

    /**
     * Get next page posts
     */
    progress_page() {

        var vm          = this,
            page_input  = vm.get_page_input()

        vm.set_page(parseInt(page_input.val()) + 1)
        vm.populate_posts()

    }

    /**
     * Set current page
     *
     * @param {int} page Page number (starting from 1)
     * @param {bool} trigger_event Whether to trigger input change event
     */
    set_page(page, trigger_event) {

        var vm          = this,
            page_input  = vm.get_page_input()

        page_input.val(page)

        if (trigger_event) page_input.change()

        vm.current_page = page

    }

    /**
     * Get current query (via form)
     *
     * By default don't include undefined inputs
     */
    get_query(skip_undefined = true) {

        var vm              = this,
            form            = vm.get_form_parts().form,
            serializedArray = form.serializeArray()

        // Inject empty checkbox input vals (so their URL params know to be removed)
        form.find( 'input[type="checkbox"]' ).each(function() {
            if ( !this.checked ) serializedArray.push({name: this.name, value: ""})
        })

        // Build up object of input names and their values
        return serializedArray.reduce(function (result, item) {
            if (
                item.name != vm.page_param && // ignore page param
                (skip_undefined && (typeof item.value != 'undefined' && item.value) || !skip_undefined) // skip undefined (if specified)
            ) {
                if ( typeof result[item.name] == 'undefined' ) {
                    result[item.name] = item.value
                } else if (item.value) {
                    // Add value as a comma list if multiple form values with the same name
                    result[item.name] = `${result[item.name]},${item.value}`
                }
            }
            return result
        }, {})

    }

    /**
     * Query and populate contain with posts
     */
    populate_posts() {

        var vm      = this,
            query   = vm.get_query(),
            append  = true

        if (!vm.is_equivalent(query, vm.last_query)) {

            vm.set_page(1, false)
            append = false

            vm.reset_container()

            $(window).trigger('mwb/plugin/post_forms/query_changed', [vm])  // trigger post form query changed event

        } else if (vm.current_page == vm.last_page) {
            return [] // Don't do anything if same page and query
        }

        $(window).trigger('mwb/plugin/post_forms/adding_posts', [vm])   // trigger post form populating posts event

        vm.last_query = query

        vm.set_url_params()

        vm.last_requested_at = (new Date()).getTime()
        vm.indicate_loading(true)

        var $payload = {
            'action':       'get_form_posts',
            'requested-at': vm.last_requested_at,
            'post-form-id': vm.post_form_id,
        }

        $payload[vm.page_param] = vm.current_page   // Set current page number

        Object.keys(query).forEach(function (key) {
            $payload[key] = query[key]
        })

        $.ajax({
            type:       'POST',
            url:        scriptVars.ajaxUrl,
            dataType:   'json',
            data:       $payload,
            success:    function (res) {

                if (res.success) {
                    var res = JSON.parse(res.data)

                    // Only use most recent request's response
                    if (res.requested_at == vm.last_requested_at) {
                        vm.indicate_loading(false)
                        vm.set_empty_html(res.empty_html)
                        vm.set_count_html(res.count_html)
                        vm.set_total_post_count(res.total_post_count)
                        vm.toggle_pagination(res.more_pages)
                        vm.add_posts(res.html, append)
                    }
                }
            },
            error:      function (err) {
                console.error('err', err)

                vm.indicate_loading(false)
                vm.add_posts('', false)
            }
        })

    }

    /**
     * Add/replace (based on 'append') given html posts to container
     *
     * @param {string} html html of posts to 'add'
     * @param {bool} append Whether to append html or replace it
     */
    add_posts(html, append) {

        var vm          = this,
            $container  = vm.get_form_parts().container

        if (append) {

            $container.append(html)

        } else {

            if (html) {

                // Replace container with new html
                $container.html(html)

            } else {

                // Display no posts found if there are none
                $container.html(vm.empty_html)
            }

        }

        vm.update_count_html()

        // Trigger added posts event
        $(window).trigger('mwb/plugin/post_forms/added_posts', [vm])

    }

    /**
     * Indicate to user loading is in progress
     */
    indicate_loading(toggle) {

        var vm          = this,
            form_parts  = vm.get_form_parts()

        form_parts.loading.toggleClass('hidden', !toggle)

        vm.toggle_pagination(!toggle)

    }

    /**
     * Toggle visibility of pagination
     *
     * @param {bool} enable Whether to show or hide pagination
     */
    toggle_pagination(enable) {

        var vm          = this,
            pagination  = vm.get_form_parts().pagination

        pagination.toggleClass('hidden', !enable)

    }

    reset_container() {

        var vm          = this,
            form_parts  = vm.get_form_parts()

        form_parts.container.html('')

    }

    /**
     * Set url parameters based on current query and page
     */
    set_url_params() {

        var vm              = this,
            query           = vm.get_query(false),
            current_page    = vm.current_page

        // Skip function if url params are disabled
        if (vm.disable_params) {
            return
        }

        // Otherwise go through and set params
        const params = new URLSearchParams(location.search)

        Object.keys(query).forEach(function (key) {

            if (vm.exclude_params.includes(key)) {
                return
            }

            if (typeof query[key] != 'undefined' && query[key]) {
                params.set(key, query[key])
            } else {
                params.delete(key)
            }

        })

        if (current_page > 1) {
            params.set(vm.page_param, current_page)
        } else {
            params.delete(vm.page_param)
        }

        params.sort()   // alphabetise params to reduce amount of post form's combinations

        window.history.replaceState({}, '', params.toString() ? `${location.pathname}?${params}` : location.pathname)

    }

    /**
     * Set/update empty html (useful for dynamic empty html)
     */
    set_empty_html(html) {
        this.empty_html = html
    }

    /**
     * Set/update count html (useful for dynamic count html)
     */
     set_count_html(html) {
        this.count_html = html
    }

    /**
     * Update count html (to indicate dynamic result counts)
     */
    update_count_html() {

        var vm          = this,
            count_html  = vm.count_html,
            $count      = vm.get_form_parts().count

        $count.html(count_html || '')

    }

    /**
     * Set/update empty html (useful for dynamic empty html)
     */
    set_total_post_count(total_post_count) {
        this.total_post_count = total_post_count
    }

    /**
     * Tests deep equivalency between two objects
     */
    is_equivalent(a, b) {

        // Create arrays of property names
        var aProps = Object.getOwnPropertyNames(a)
        var bProps = Object.getOwnPropertyNames(b)

        // If number of properties is different,
        // objects can't be equivalent
        if (aProps.length != bProps.length) return false

        for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i]

            // If values of same property are not equal,
            // objects are not equivalent
            if (a[propName] !== b[propName]) return false
        }

        // If we made it this far, objects
        // are considered equivalent
        return true

    }

}

export default PostForms